import { Button, Table } from "antd";
import dayjs from "dayjs";
import { Client } from "../../entities/interfaces/client";

type Props = {
  clients: Client[];
  onSelect: (client: Client) => void;
};

const ClientList = ({ clients, onSelect }: Props) => {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "DOB",
      key: "dob",
      render: (record: Client) =>
        record.dob ? <p>{dayjs(record.dob).format("DD/MM/YYYY")}</p> : "N/A",
    },
    {
      title: "Gender",
      key: "gender",
      render: (record: Client) => (
        <p className="capitalize">{record.gender.toLowerCase()}</p>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (record: any) => {
        return (
          <Button size="small" onClick={() => onSelect(record)}>
            Update
          </Button>
        );
      },
    },
  ];

  return <Table dataSource={clients} columns={columns} pagination={false} />;
};

export default ClientList;
